import i18next from "i18next";
import { initReactI18next } from 'react-i18next';

import translationEnglish from "./Translations/translation.en.json";
import translationFrench from "./Translations/translation.fr.json";
import translationArabic from "./Translations/translation.ar.json";
import translationDeutsh from "./Translations/translation.de.json";

const resources = {
    en: {
        translation: translationEnglish,
    },
    fr: {
        translation: translationFrench,
    },
    ar: {
        translation: translationArabic,
    },
    de: {
        translation: translationDeutsh,
    }
}

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // default EN
    });

export default i18next;
